import React from 'react'
import { IconButton, Tooltip } from '@mui/material'
import { makeStyles } from '@mui/styles'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import lang from 'lang'

const useStyles = makeStyles((theme) => ({
  iconButton: ({ positionStrategy }: { positionStrategy: 'fixed' | 'absolute' }) => ({
    position: positionStrategy,
    zIndex: 12,
    backgroundColor: theme.primary,
    color: theme.white,
    width: 32,
    height: 32,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    '&:hover': {
      backgroundColor: theme.primaryDark,
      transform: 'scale(1.1)',
    },
  }),
  icon: {
    fontSize: 18,
  },
  tooltip: {
    fontSize: theme.fontSizes.tooltip,
  },
}))

interface AiTextTransformButtonProps {
  position: { top: number; left: number } | null
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  visible: boolean
  positionStrategy?: 'fixed' | 'absolute'
}

export const AiTextTransformButton: React.FC<AiTextTransformButtonProps> = ({
  position,
  onClick,
  visible,
  positionStrategy = 'absolute',
}) => {
  const classes = useStyles({ positionStrategy })

  if (!visible || !position) {
    return null
  }

  // Prevent input from losing focus when clicking on icon
  const handleMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    event.stopPropagation()
    onClick(event)
  }

  return (
    <Tooltip title={lang.ai.textTransform.button.tooltip} placement="top" classes={{ tooltip: classes.tooltip }}>
      <IconButton
        className={classes.iconButton}
        onClick={handleClick}
        onMouseDown={handleMouseDown}
        size="small"
        style={{
          top: position.top,
          left: position.left,
        }}
      >
        <AutoAwesomeIcon className={classes.icon} />
      </IconButton>
    </Tooltip>
  )
}
